import { NUM_CONTRATO_SAFI } from './filters';
import {
  AUMENTO_DE_PLAZO,
  SOLICITUDES_VARIAS,
  ACUCORE,
  ACTRE,
  MEMO,
  OFICIO,
  OFCORE,
  RES,
  RESUGDPS,
  BIT,
  ODP,
  SP,
  SCP,
  INF,
  CEF,
  SOGR,
  SEGR,
  IDPC
} from './templates';

export const AGUAS_ANDINAS = {
  rut: '61808000-5',
  notHasfilters: [NUM_CONTRATO_SAFI],
  id: 'f18925d2-2b22-4579-a68c-d9e491752b3e',
  group: 'Grupo de QA',
  documentType: 'Carta',
  repoForm: {
    AUMENTO_DE_PLAZO,
    SOLICITUDES_VARIAS
  },
  repositoryName: 'AGUAS ANDINAS S A',
};
export const FEBOS_SA = {
  rut: '76179952-5',
  notHasfilters: [NUM_CONTRATO_SAFI],
  group: 'Grupo automatización',
  office: 'QA-office',
  documentType: 'Resolución',
  document: 'Resolución afecta',
  internalOffice: 'QA-office-interna',
  documentoTypeInternal: 'Boletas numeracion',
  documentInternal: 'Boleta de Garantía',
  documentTypeWithoutNumbering: 'Sin numeración',
  documentWithoutNumbering: 'Sin numeración',
  typeOfInstitution: 'MUNICIPALIDAD DE LAS CONDES',
  institution: 'DEPARTAMENTE DE TRANSPORTE',
  massApproveTemplate: 'Aprobar Masivo',
  templateRejectMass: 'Rechazar Masivo',
  templateSignMassive: 'Firmar Masivo',
  templateAttended: 'Automatización atendido',
  category: 'Prueba QA',
  subCategory: 'Automatizaciones',
  repositoryName: 'SERVICIOS INFORMATICOS IA SOLUTIONS LIMITADA'

};
export const CONVENCION = { rut: '60100003-2', notHasfilters: [NUM_CONTRATO_SAFI] };
export const SUPERINTENDENCIA_DE_SERVICIOS_SANITARIOS = {
  rut: '61221000-4',
  notHasfilters: [NUM_CONTRATO_SAFI],
  id: '2486bfa6-e81a-454e-94b5-936008caef54',
  group: 'Grupo automatización',
  office: 'QA-office',
  documentType: 'Categoria de QA',
  document: 'Documento de QA',
  documentTypewithoutNumbering: 'Circulares',
  documentwithoutNumbering: 'Circular',
};
export const SISS = SUPERINTENDENCIA_DE_SERVICIOS_SANITARIOS;
export const MOP = { rut: '61202000-0', hasFilters: [NUM_CONTRATO_SAFI] };
export const ADUANAS_CENTRAL = {
  rut: '60804000-5',
  notHasfilters: [NUM_CONTRATO_SAFI],
  id: '5de65905-6555-4a45-9794-12329e7e8e29'
};
export const SERCOTEC = { rut: '82174900-k', hasFilters: [NUM_CONTRATO_SAFI] };
export const GORE_VALP = {
  rut: '72235100-2',
  notHasFilters: [NUM_CONTRATO_SAFI],
  id: 'b6df5454-69c1-4df7-b2a5-cedd7580a330',
  profiles: {
    perfilEstándar: {
      perfilId: '577a52b8-796c-4a18-821a-1e4c7f07716f',
    },
    perfilAdministrador: {
      perfilId: 'cd82918c-6337-4d16-ac45-11f2ddab0dc4',

    }
  },
  template: 'Prueba de automatización',
  repositoryName: 'GOBIERNO REGIONAL V REGION',
  office: 'Oficina Automatización',
  internalOffice: 'Oficina Interna',
  repoForm: {
    ACUCORE,
    ACTRE,
    MEMO,
    OFICIO,
    OFCORE,
    RES,
    RESUGDPS,
    BIT,
    ODP,
    SP,
    SCP,
    INF,
    CEF,
    SOGR,
    SEGR,
    IDPC
  },
  group: 'Grupo automatización',
};
export const FEBOS_AMI = {
  rut: '76936898-1',
  unattendedTemplate: 'Desatendido automatización'
};
export const LABORATORIO_SAVAL = {
  rut: '91650000-9',
  repositoryName: 'Laboratorios Saval'
};
